import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../_services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-login-by-token',
  templateUrl: './login-by-token.component.html',
  styleUrls: ['./login-by-token.component.scss']
})
export class LoginByTokenComponent implements OnInit {

  constructor(private auth: AuthService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.auth.loginUserWithToken(params.uidb, params.token).subscribe(
        response => {
          if (response.token) {
            this.router.navigate(['/']);
          } else {
            this.router.navigate(['/login']);
          }
        }
      );
    });
  }

}
